// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__io4gJ","tooltip-container":"Tooltip_tooltip-container__2IyV+"};